import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from '@angular/core';
import { catchError, filter, finalize, map, mergeMap, Observable, of, ReplaySubject, switchMap, take, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { API_CONSTANTS } from 'src/app/features/shared/constants/api';
import { StorageService } from "./storage.service";
import { NavigationEnd, Router } from "@angular/router";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { ConfirmationDialogComponent } from "../dashboard/orders/modals/confirmation-dialog/confirmation-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  responseType = {
    observe: "response",
  };
  miniCartSubject = new ReplaySubject(1);
  selectedEnvironment: string = "";
  modalRef!: BsModalRef;
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private router: Router,
    private modalService: BsModalService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.handleDuplicateSession();
      });
  }

  get(url: any, options: any = {}): Observable<any> {
    this.handleDuplicateSession();
    let requestOptions = { ...this.responseType, ...options };
    return this.http.get(`${environment.apiBaseUrl}${url}`, requestOptions).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  };

  post(endpoint: any, payload: any, options: any = {}, baseUrlIncluded = false) {
    let requestOptions = { ...options, ...this.responseType };
    const url = `${baseUrlIncluded ? '' : environment.apiBaseUrl}${endpoint}`;
    return this.http
      .post(url, payload, requestOptions)
      .pipe(
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
  };

  put(url: any, payload: any, options: any = {}) {
    let requestOptions = { ...options, ...this.responseType };
    return this.http
      .put(`${environment.apiBaseUrl}${url}`, payload, requestOptions)
      .pipe(catchError((error: HttpErrorResponse) => of(error)));
  }

  patch(url: any, payload: any, options: any = {}) {
    let requestOptions = { ...options, ...this.responseType };
    return this.http
      .patch(`${environment.apiBaseUrl}${url}`, payload, requestOptions)
      .pipe(catchError((error: HttpErrorResponse) => of(error)));
  };

  delete(url: any, options: any = {}): Observable<any> {
    let requestOptions = { ...options, ...this.responseType };
    return this.http
      .delete(`${environment.apiBaseUrl}${url}`, requestOptions)
      .pipe(catchError((error: HttpErrorResponse) => of(error)));
  };

  getMiniCart(data: any = {}):Observable<any> {
    return of(this.getMiniCartData(data).subscribe({
      next: (result: any) => {
        // TODO: #getBuilderCart As getBuilderCart endpoint not working we are now depenedet to minicart only as backend developer suggested
        if (result) {
          this.storageService.setItem("cart", {
            code : result?.code || '',
            totalItems: result?.totalItems || 0, 
          }
          );
          this.storageService.setItem("miniCartCount",result)
          this.miniCartSubject.next(result);
        } else {
          this.storageService.setItem("cart", "");
          this.storageService.setItem("miniCartCount","")
          this.miniCartSubject.next(""); 
        }
        // this.fetchBuilderCart$().subscribe({
        //   next: (res) => {
        //     console.log(res, 'fetchBuilderCart');
        //     if (res) {
        //       this.storageService.setItem("cart", {
        //         code : result?.code || '',
        //         totalItems: result?.totalItems || 0, 
        //       }
        //       );
        //       this.storageService.setItem("miniCartCount",result)
        //       this.miniCartSubject.next(result);
        //     } else {
        //       this.storageService.setItem("cart", "");
        //       this.storageService.setItem("miniCartCount","")
        //       this.miniCartSubject.next(""); 
        //     }
        //   }
        // })
      },
      error: (error: any) => {
        this.storageService.setItem("cart", "");
        this.storageService.setItem("miniCartCount","")
        this.miniCartSubject.next("");
      },
    }))
    
  }
  getMiniCartData(data:any): Observable<any> {
    const url = API_CONSTANTS.miniCart
      .replace("{uid}", data?.uid)
      .replace("{customerNumber}", data?.customerNumber);
    return this.http.get(`${environment.apiBaseUrl}${url}`).pipe();
  }

  // getPdpRecords(id: any): Observable<any> {
  //   const url = API_CONSTANTS.pdpData;
  //   return this.getUsingDynamicCatalog(url + id + `/productDetails` + `${"?fields=FULL"}`)
  //     .pipe(catchError((error: HttpErrorResponse) => of(error)));
  // }

  getUsingDynamicCatalog(url: any, options: any = {}): Observable<any> {
    let requestOptions = { ...this.responseType, ...options };
    return this.http.get(environment.apiBaseUrl+ url, requestOptions).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      })
    );
  }

  // getUOMDetails(id: any) {
  //   const url = API_CONSTANTS.UOMDetails.replace("{productId}", id);
  //   return this.getUsingDynamicCatalog(url);
  // }

  fetchBuilderCart$() {
    return this.storageService.getItem(["customer-details", "selected-builder"])
    .pipe(
      take(1),
      map(([customerDetails, selectedBuilder]) => ({
        userId: customerDetails?.uid,
        builderNumber: selectedBuilder?.builderNumber
      })),
      switchMap(data => {
        const endpoint = API_CONSTANTS.getBuilderCart
          .replace("{userId}", data.userId)
          .replace("{builderNumber}", data.builderNumber);
        return this.http.get(`${environment.apiBaseUrl}${endpoint}`).pipe();
      })
    );
  }
  
  getAsm(url: any, options: any = {}): Observable<any> {
    let token = sessionStorage.getItem("token") || "";
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      BearerToken: `Bearer ${token}`,
      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Headers": "Content-Type",
      // Accept: "*/*",
    });

    let requestOptions = { ...this.responseType, ...options, headers };
    return this.http
      .get(this.setBaseSiteIdAsm(url), requestOptions)
      .pipe(catchError((error: HttpErrorResponse) => of(error)));
  }
  setBaseSiteIdAsm(url: string) {
    const formatedURl: string =
      environment.apiBaseUrl +
      this.getEnvirontmentAsm() +
      "/" +
      url;
    return formatedURl;
  }
  getEnvirontmentAsm() {
    const url =
      this.router.url == "/"
        ? window.location.href
        : this.router.url.split("?")[0];
    return url.includes("commercial")
      ? "mhkflooringBMF"
      : "mhkflooringBMF";
  }
  postASM(url: any, payload: any, options: any = {}): Observable<any> {
    let requestOptions = { ...options, ...this.responseType };
    return this.http.post(this.setBaseSiteIdAsm(url), payload, requestOptions);
  }

  getMiniCartV2(data: any = {}): Observable<any> {
    return this.getMiniCartData(data).pipe(
      switchMap((result: any) => {
        return this.fetchBuilderCart$().pipe(
          map((res) => {
            if (result) {
              this.storageService.setItem("cart", {
                code : result?.code || '',
                totalItems: result?.totalItems || 0, 
              });
              this.storageService.setItem("miniCartCount",result)
              this.miniCartSubject.next(result);
            } else {
              this.storageService.setItem("cart", "");
              this.storageService.setItem("miniCartCount","")
              this.miniCartSubject.next(""); 
            }
            return result; // Return the final result here if needed
          })
        );
      }),
      catchError((error: any) => {
        this.storageService.setItem("cart", "");
        this.storageService.setItem("miniCartCount", "");
        this.miniCartSubject.next("");
        return throwError(error);
      })
    );
  }
  
  postDifferentUrl(url: any, payload: any, options: any = {}): Observable<any> {
    const headers = new HttpHeaders()
      // .set(
      //   "Authorization",
      //   "Basic " +
      //     btoa(
      //       `${environment.addressValidationClientId}:${environment.addressValidationSecret}`
      //     )
      // )
      .set("Content-Type", "application/json")
      .set("skipAuth", "true")
      .set("InterceptorSkipHeader", "");
    return this.http.post(url, payload, { headers: headers });
  }

  /**
   * Check duplicate session
   */

  isGettingUnit: boolean = false;

  getDefaultUnit(data: any = {}) {
    const endpoint = API_CONSTANTS.getDefaultUnit
      .replace("{userId}", data.userId);
    return this.get(endpoint).pipe(map(({ body }) => body));
  }

  handleDuplicateSession(): void {
      if (this.isGettingUnit) {
        return;
      }
      this.isGettingUnit = true;
      let userInfo: any = {};
      this.storageService
        .getItem("customer-details")
        .pipe(
          finalize(() => this.isGettingUnit = false),
          take(1),
          mergeMap((customerDetails) => {
            userInfo = customerDetails;
            const isProhibitedRoute = [
              "/salesman-dashboard",
              "/salesman-view-account",
              "/csr",
            ].some((item) => (this.router.url || "").includes(item));
            const shouldCheckDuplicateLogin =
              (customerDetails?.isCSR ||
                customerDetails?.isSalesOpsUser ||
                (customerDetails?.isSalesPerson && customerDetails?.orgUnit?.accountType !== "ZMSH")) &&
              customerDetails?.orgUnit?.uid !== "EMPTY_B2BUNIT" &&
              !isProhibitedRoute;
            return shouldCheckDuplicateLogin
              ? this.getDefaultUnit({
                  userId: customerDetails?.uid,
                })
              : of(null);
          }),
          map((res) => (res ? res?.id !== userInfo?.orgUnit?.uid : false))
        )
        .subscribe((hasDuplicateLogin) => {
          if (hasDuplicateLogin) {
            if (userInfo?.isCSR) {
              this.router.navigate(["/csr"], {
                queryParams: { exit: true },
              });
            } else {
              this.router.navigate(["/salesman-view-account"]);
            }
            this.openConfirmationModal({
              title: "Error",
              content: `You have logged in to more than one browser with different ${
                userInfo?.isCSR ? "retailers" : "accounts"
              }. Please select the account again`,
              primaryActionLabel: "Ok",
              disableSecondaryAction: true,
              onPrimaryAction: () => {
                window.location.reload();
              },
            });
          }
        });
    }

    openConfirmationModal(data: any = {}) {
        const initialState: ModalOptions = {
          backdrop: true,
          ignoreBackdropClick: true,
          initialState: {
            ...data,
          },
        };
        this.modalRef = this.modalService.show(
          ConfirmationDialogComponent,
          Object.assign(initialState, {
            id: data?.modalId || "",
            class: "modal-md modal-dialog-centered",
          })
        );
      }
}
